"use client";

import React from "react";

const placementStyles = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2",
};

/**
 * Tooltip - Popover content for OverlayTrigger.
 */
export function Tooltip({
  id,
  children,
  className = "",
  placement = "top",
  // OverlayTrigger passes { show, ... } into Tooltip via spread
  // We intentionally ignore `show` to avoid leaking it to the DOM.
  show,
  ...props
}) {
  return (
    <div
      id={id}
      role="tooltip"
      className={`absolute z-[9999] px-3 py-2 text-sm text-white bg-darkBlack rounded shadow-lg whitespace-nowrap ${placementStyles[placement]} ${className}`.trim()}
      {...props}
    >
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}
